
import { newsletterService } from '../services';
import baseMethods from './base';

const initialState = {  newsletter: {data: null,status:{ loading: false,ready: false }},
                        templates: {data: null,status:{ loading: false,ready: false }},
                        recuserdata: {data: null,status:{ loading: false,ready: false }},
                        reclists: {data: null,status:{ loading: false,ready: false }}
                    };

export const newsletter = {
    namespaced: true,
    state: initialState,
    actions: {
        getAllNewsletter({ commit },data )
        {
            commit('getAllNewsletterRequest' );
            return new Promise((resolve, reject) => {

                newsletterService.getAllNewsletter(data).then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('getAllNewsletterSuccess',response.data);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('getAllNewsletterFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },
        // eslint-disable-next-line no-unused-vars
        getNewsletterPrev({ commit },data )
        {
            return new Promise((resolve, reject) => {

                newsletterService.getNewsletterPrev(data).then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            resolve(response.data);
                        }
                        else
                        {
                            reject(response.statusText);
                        }
                    }
                );

            })
        },        
        deleteNewsletter({ commit }, id)
        {
            commit('deleteNewsletterRequest' );
            return new Promise((resolve, reject) => {
                
                newsletterService.deleteNewsletter(id).then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('deleteNewsletterSuccess',id);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('deleteNewsletterFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },      
        saveNewsletter({ commit }, data)
        {
            return new Promise((resolve, reject) => {
                
                if(data.id <= 0)
                {
                    commit('insertNewsletterRequest' );
                    newsletterService.insertNewsletter(data).then(
                        response => {
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('insertNewsletterSuccess');
                                resolve(response.data);
                            }
                            else
                            {
                                commit('insertNewsletterFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
                else
                {
                    commit('updateNewsletterRequest' );
                    newsletterService.updateNewsletter(data).then(
                        response => {
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('updateNewsletterSuccess',data);
                                resolve(response.data);
                            }
                            else
                            {
                                commit('updateNewsletterFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
            })
        },


        getAllTemplates({ commit },data )
        {
            commit('getAllTemplatesRequest' );
            return new Promise((resolve, reject) => {

                newsletterService.getAllTemplates(data).then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('getAllTemplatesSuccess',response.data);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('getAllTemplatesFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },
        deleteTemplate({ commit }, id)
        {
            commit('deleteTemplateRequest' );
            return new Promise((resolve, reject) => {
                
                newsletterService.deleteTemplate(id).then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('deleteTemplateSuccess',id);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('deleteTemplateFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },      
        saveTemplate({ commit }, data)
        {
            return new Promise((resolve, reject) => {
                
                if(data.id <= 0)
                {
                    commit('insertTemplateRequest' );
                    newsletterService.insertTemplate(data).then(
                        response => {
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('insertTemplateSuccess');
                                resolve(response.data);
                            }
                            else
                            {
                                commit('insertTemplateFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
                else
                {
                    commit('updateTemplateRequest' );
                    newsletterService.updateTemplate(data).then(
                        response => {
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('updateTemplateSuccess',data);
                                resolve(response.data);
                            }
                            else
                            {
                                commit('updateTemplateFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
            })
        },
        

        getAllReclists({ commit },data )
        {
            commit('getAllReclistsRequest' );
            return new Promise((resolve, reject) => {

                newsletterService.getAllReclists(data).then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('getAllReclistsSuccess',response.data);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('getAllReclistsFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },
        deleteReclist({ commit }, id)
        {
            commit('deleteReclistRequest' );
            return new Promise((resolve, reject) => {
                
                newsletterService.deleteReclist(id).then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('deleteReclistSuccess',id);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('deleteReclistFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },      
        saveReclist({ commit }, data)
        {
            return new Promise((resolve, reject) => {
                
                if(data.id <= 0)
                {
                    commit('insertReclistRequest' );
                    newsletterService.insertReclist(data).then(
                        response => {
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('insertReclistSuccess');
                                resolve(response.data);
                            }
                            else
                            {
                                commit('insertReclistFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
                else
                {
                    commit('updateReclistRequest' );
                    newsletterService.updateReclist(data).then(
                        response => {
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('updateReclistSuccess',data);
                                resolve(response.data);
                            }
                            else
                            {
                                commit('updateReclistFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
            })
        },
        getRecUserData({ commit },data )
        {
            commit('getRecUserDataRequest' );
            return new Promise((resolve, reject) => {

                newsletterService.getRecUserData(data).then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('getRecUserDataSuccess',response.data);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('getRecUserDataFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },
        
        deleteReclistMem({ commit }, id)
        {
            commit('deleteReclistMemRequest' );
            return new Promise((resolve, reject) => {
                
                newsletterService.deleteReclistMem(id).then(
                    response => {
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('deleteReclistMemSuccess',id);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('deleteReclistMemFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },      
        saveReclistMem({ commit }, data)
        {
            return new Promise((resolve, reject) => {
                
                if(data.id <= 0)
                {
                    commit('insertReclistMemRequest' );
                    newsletterService.insertReclistMem(data).then(
                        response => {
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('insertReclistMemSuccess');
                                resolve(response.data);
                            }
                            else
                            {
                                commit('insertReclistMemFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
                else
                {
                    commit('updateReclistMemRequest' );
                    newsletterService.updateReclistMem(data).then(
                        response => {
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('updateReclistMemSuccess',data);
                                resolve(response.data);
                            }
                            else
                            {
                                commit('updateReclistMemFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
            })
        }         
    },
    mutations: {
        getAllNewsletterRequest(state)
        {
            state.newsletter = {
                data: null,
                status:{ loading: true,ready: false }
            };
        },
        getAllNewsletterSuccess(state, data)
        {
            state.newsletter = {
                data: data,
                status:{ loading: false,ready: true }
            };
        },
        getAllNewsletterFailure(state)
        {
            state.newsletter = {
                data: null,
                status:{ loading: false,ready: false }
            };
        },
        deleteNewsletterRequest(state)
        {
            state.newsletter.status = { loading: true,ready: false };
        },
        deleteNewsletterSuccess(state,id)
        {
            state.newsletter.status = { loading: false,ready: true };
            for(var i =0; i < state.newsletter.data.length;i++)
            {
                if(state.newsletter.data[i].id == id)
                {
                    state.newsletter.data.splice(i,1);
                }
            }

        },
        deleteNewsletterFailure(state)
        {
            state.newsletter.status = { loading: false,ready: false };
        },
        insertNewsletterRequest(state)
        {
            state.newsletter.status = { loading: true,ready: false };
        },
        insertNewsletterSuccess(state)
        {
            state.newsletter.status = { loading: false,ready: true };
        },
        insertNewsletterFailure(state)
        {
            state.newsletter.status = { loading: false,ready: false };
        },
        updateNewsletterRequest(state)
        {
            state.newsletter.status = { loading: true,ready: false };
        },
        updateNewsletterSuccess(state,data)
        {
            state.newsletter.status = { loading: false,ready: true };
            for(var i =0; i < state.newsletter.data.length;i++)
            {
                if(state.newsletter.data[i].id == data.id)
                {
                    var tmp = JSON.stringify(data);
                    state.newsletter.data[i] = JSON.parse(tmp);
                }
            }
        },
        updateNewsletterFailure(state)
        {
            state.newsletter.status = { loading: false,ready: false };
        },        
        
        
        
        getAllTemplatesRequest(state)
        {
            state.templates = {
                data: null,
                status:{ loading: true,ready: false }
            };
        },
        getAllTemplatesSuccess(state, data)
        {
            state.templates = {
                data: data,
                status:{ loading: false,ready: true }
            };
        },
        getAllTemplatesFailure(state)
        {
            state.templates = {
                data: null,
                status:{ loading: false,ready: false }
            };
        },
        deleteTemplateRequest(state)
        {
            state.templates.status = { loading: true,ready: false };
        },
        deleteTemplateSuccess(state,id)
        {
            state.templates.status = { loading: false,ready: true };
            for(var i =0; i < state.templates.data.length;i++)
            {
                if(state.templates.data[i].id == id)
                {
                    state.templates.data.splice(i,1);
                }
            }

        },
        deleteTemplateFailure(state)
        {
            state.templates.status = { loading: false,ready: false };
        },
        insertTemplateRequest(state)
        {
            state.templates.status = { loading: true,ready: false };
        },
        insertTemplateSuccess(state)
        {
            state.templates.status = { loading: false,ready: true };
        },
        insertTemplateFailure(state)
        {
            state.templates.status = { loading: false,ready: false };
        },
        updateTemplateRequest(state)
        {
            state.templates.status = { loading: true,ready: false };
        },
        updateTemplateSuccess(state,data)
        {
            state.templates.status = { loading: false,ready: true };
            for(var i =0; i < state.templates.data.length;i++)
            {
                if(state.templates.data[i].id == data.id)
                {
                    var tmp = JSON.stringify(data);
                    state.templates.data[i] = JSON.parse(tmp);
                }
            }
        },
        updateTemplateFailure(state)
        {
            state.templates.status = { loading: false,ready: false };
        }, 


        getAllReclistsRequest(state)
        {
            state.reclists = {
                data: null,
                status:{ loading: true,ready: false }
            };
        },
        getAllReclistsSuccess(state, data)
        {
            state.reclists = {
                data: data,
                status:{ loading: false,ready: true }
            };
        },
        getAllReclistsFailure(state)
        {
            state.reclists = {
                data: null,
                status:{ loading: false,ready: false }
            };
        },
        getRecUserDataRequest(state)
        {
            state.recuserdata = {
                data: null,
                status:{ loading: true,ready: false }
            };
        },
        getRecUserDataSuccess(state, data)
        {
            state.recuserdata = {
                data: data,
                status:{ loading: false,ready: true }
            };
        },
        getRecUserDataFailure(state)
        {
            state.recuserdata = {
                data: null,
                status:{ loading: false,ready: false }
            };
        },        
        deleteReclistRequest(state)
        {
            state.reclists.status = { loading: true,ready: false };
        },
        deleteReclistSuccess(state,id)
        {
            state.reclists.status = { loading: false,ready: true };
            for(var i =0; i < state.reclists.data.length;i++)
            {
                if(state.reclists.data[i].id == id)
                {
                    state.reclists.data.splice(i,1);
                }
            }

        },
        deleteReclistFailure(state)
        {
            state.reclists.status = { loading: false,ready: false };
        },
        insertReclistRequest(state)
        {
            state.reclists.status = { loading: true,ready: false };
        },
        insertReclistSuccess(state)
        {
            state.reclists.status = { loading: false,ready: true };
        },
        insertReclistFailure(state)
        {
            state.reclists.status = { loading: false,ready: false };
        },
        updateReclistRequest(state)
        {
            state.reclists.status = { loading: true,ready: false };
        },
        updateReclistSuccess(state,data)
        {
            state.reclists.status = { loading: false,ready: true };
            for(var i =0; i < state.reclists.data.length;i++)
            {
                if(state.reclists.data[i].id == data.id)
                {
                    var tmp = JSON.stringify(data);
                    state.reclists.data[i] = JSON.parse(tmp);
                }
            }
        },
        updateReclistFailure(state)
        {
            state.reclists.status = { loading: false,ready: false };
        },   
        
        



        deleteReclistMemRequest(state)
        {
            state.reclists.status = { loading: true,ready: false };
        },
        deleteReclistMemSuccess(state,id)
        {
            state.reclists.status = { loading: false,ready: true };

            state.reclists.data.forEach(reclist => {
                for(var i =0; i < reclist.member.length;i++)
                    {
                        if(reclist.member[i].id == id)
                        {
                            reclist.member.splice(i,1);
                        }
                    }
            });
        },
        deleteReclistMemFailure(state)
        {
            state.reclists.status = { loading: false,ready: false };
        },
        insertReclistMemRequest(state)
        {
            state.reclists.status = { loading: true,ready: false };
        },
        insertReclistMemSuccess(state)
        {
            state.reclists.status = { loading: false,ready: true };
        },
        insertReclistMemFailure(state)
        {
            state.reclists.status = { loading: false,ready: false };
        },
        updateReclistMemRequest(state)
        {
            state.reclists.status = { loading: true,ready: false };
        },
        updateReclistMemSuccess(state,data)
        {
            state.reclists.status = { loading: false,ready: true };

            state.reclists.data.forEach(reclist => {
                for(var i =0; i < reclist.member.length;i++)
                    {
                        if(reclist.member[i].id == data.id)
                        {
                            var tmp = JSON.stringify(data);
                            reclist.member[i] = JSON.parse(tmp);
                        }
                    }
            });
        },
        updateReclistMemFailure(state)
        {
            state.reclists.status = { loading: false,ready: false };
        }, 
    }
}
